import { createContext } from 'react';
import config, { AppConfig } from '../../config';

export const buildConfigContext = (): AppConfig => {
  return config;
};

export const ConfigContext = createContext<AppConfig>(buildConfigContext());
